import React from 'react';
import NiceModal from 'components/NiceModal';
import { ManageColumnsForm } from './ManageColumnsForm';

/**
 * Thin presentation wrapper: puts the form inside a NiceModal frame.
 *
 * Separate from the form so the form can be embedded in non-modal
 * contexts (inline settings, preview surfaces) without copy-pasting
 * the data-fetching layer.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {Array} props.sections
 * @param {boolean} props.isLoading
 * @param {(checkedIds: string[]) => void} props.onSave
 */
export function ManageColumnsModal({ isOpen, onClose, sections, isLoading, onSave }) {
    return (
        <NiceModal
            isOpen={isOpen}
            shouldCloseOnOverlayClick
            onRequestClose={onClose}
            title="Manage Columns"
            style={{ content: { width: '560px' } }}
        >
            <ManageColumnsForm sections={sections} isLoading={isLoading} onClose={onClose} onSave={onSave} />
        </NiceModal>
    );
}
